import React, { useState, useEffect } from 'react'
import { ApiHttpService } from 'cms/utils/http/api'
import SelectCoursePeopleModalController from '../controller/SelectCoursePeopleModalController'
import SelectCoursePeopleModal from './SelectPeople'
import SelectUserGalleryCategory from './SelectUserGalleryCategory'
import SelectCourses from '../../../../components/SelectCourses'

function VideoGalleryForm({ initialCourse, editingItem, ...props }) {

    const [url, setUrl] = useState("")
    const [title, setTitle] = useState("")
    const [course, setCourse] = useState(initialCourse != null && initialCourse !== '' ? initialCourse : null)
    const [userId, setUserId] = useState(null)
    const [selectPeopleModalIsOpen, setSelectPeopleModalIsOpen] = useState(false)
    const [selected_person_image, setSelectedPersonImage] = useState("/assets/images/default.png")
    const [selected_person_name, setSelectedPersonName] = useState("Select User")
    const [category, setCategory] = useState(null)
    
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [done, setDone] = useState(null)

    useEffect(() => {
        if (editingItem) return
        if (initialCourse != null && initialCourse !== '') {
            setCourse(initialCourse)
        }
    }, [initialCourse, editingItem])

    useEffect(() => {
        if (!editingItem) return
        setUrl(editingItem.url || '')
        setTitle(editingItem.title || '')
        setCategory(editingItem.category != null && editingItem.category !== '' ? editingItem.category : null)
        setCourse(editingItem.course != null && editingItem.course !== '' ? editingItem.course : null)
        setError(null)
        setDone(null)
        if (editingItem.user) {
            setUserId(editingItem.user.id)
            const p = editingItem.user.profile
            if (p) {
                setSelectedPersonImage(p.thumb || '/assets/images/default.png')
                setSelectedPersonName(`${p.first_name || ''} ${p.last_name || ''}`.trim() || 'User')
            } else {
                setSelectedPersonName('User')
            }
        } else {
            setUserId(null)
        }
    }, [editingItem])

    const SaveChanges = () => {

        setError(null)

        if (!url) {
            setError("Please enter Url")
            return;
        }

        // if (!userId) {
        //     setError("Please select a user")
        //     return;
        // }

        setLoading(true)
        ApiHttpService.saveUserGallery(userId, url, title, category, course, editingItem?.id).then(data => {
            if (data.id) {
                setDone("Changes saved successfully");
                props.callback(data)
            }
            setLoading(false)
        }).catch(() => {
            setLoading(false)
            setError('Save failed')
        })
    }

    const setSelectedUser = (user) => {
        setUserId(user.id)
        setSelectedPersonImage(user.profile.thumb)
        setSelectedPersonName(user.profile.first_name + " " + user.profile.last_name)
    }

    const onChange = (e) => {
        //alert(e.target.name)
        switch (e.target.name) {
            case 'url':
                setUrl(e.target.value)
                break;
            case 'title':
                    setTitle(e.target.value)
                    break;
            default:

                break;
        }
    }

    const handleValue = (value, name) => {
        switch (name) {
            case "category":
                setCategory(value)
                break;
            case "course":
                setCourse(value)
                break;
            default:
                break;
        }
    }


    return (
        <div className="video-gallery-add-form">
            <div className="form-group">
                <input type="text" value={url} name="url" onChange={onChange} className="form-control post-title video-gallery-add-input" placeholder="https://youtu.be" />
            </div>
            <div className="form-group">
                <input type="text" value={title} name="title" onChange={onChange} className="form-control post-title video-gallery-add-input" placeholder="Title" />
            </div>
            <div className="row video-gallery-add-form__selects">
                <div className="col-sm-6 col-xs-12 form-group mb-5">
                    <SelectUserGalleryCategory menuPortal callback={handleValue} value={category} width="100%" />
                </div>
                <div className="col-sm-6 col-xs-12 form-group mb-5">
                    <SelectCourses menuPortal width="100%" placeholder="Contest" callback={handleValue} value={course} />
                </div>
            </div>
            <div className="form-group select-person-box">
                <img className='select-people-img' src={selected_person_image} alt="" onClick={() => setSelectPeopleModalIsOpen(true)} />
                <br />
                <h4 className='color-white'>{selected_person_name}</h4>
            </div>

            <div className="form-group mt-10">
                <button className="btn btn-cm pull-right" onClick={SaveChanges}>{loading ? "" : "Save Changes"}</button>
                <div className="clear"></div>
            </div>
            {error &&
                <div className="alert alert-danger mt-5">
                    {error}
                </div>
            }
            {loading &&
                <div className="alert alert-info  mt-5">
                    Please Wait...
                </div>
            }
            {done &&
                <div className="alert alert-success  mt-5">
                    {done}
                </div>
            }

            <SelectCoursePeopleModal
                course={20}
                isOpen={selectPeopleModalIsOpen}
                key={"cpm" + selectPeopleModalIsOpen}
                excludeIds={[]}
                setSelectedItem={(item) => {
                    if (item) {
                        console.log(item)
                        var user = 0;
                        if (item?.usertalent != null) {
                            user = item.usertalent.user
                        }
                        else {
                            user = item.user
                        }
                        setSelectedUser(user)
                    }
                    setSelectPeopleModalIsOpen(false)
                }}
                onClose={() => {
                    setSelectPeopleModalIsOpen(false)
                }}
            />



        </div>
    )
}

export default VideoGalleryForm